import styled from 'styled-components';

export const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: 444;
  margin-bottom: 16px;
`;

export const Panel = styled.div`
  border: 1px solid #e5e9e7;
  border-radius: 4px;
  padding: 24px;
  position: relative;
  background: #fff;

  & + & {
    margin-top: 24px;
  }
`;

export const TaxBrackets = styled.div`
  position: absolute;
  top: 76px;
  left: 34px;
  display: flex;

  > * + * {
    margin-left: 16px;
  }
`;

export const Row = styled.div<{ bold?: boolean; bottomBordered?: boolean }>`
  display: flex;
  justify-content: space-between;
  font-weight: ${props => props.bold && 'bold'};
  border-bottom: ${props => props.bottomBordered && '1px solid rgba(156, 156, 156, 0.5)'};
  padding: 8px 0;
  color: #6C727F;

  > * {
    flex-basis: 100%;
    text-align: right;
  }
`;
